import React from "react";
import styles from "./servicespoint.module.css";
import { useEffect, useRef, useState } from "react";
import { ReactComponent as GlobalIcon } from "../../../../../assests/service_points/hardware_1-line-91.svg";
import { ReactComponent as RobustIcon } from "../../../../../assests/service_points/hardware_1-line-41.svg";
import { ReactComponent as ExpertIcon } from "../../../../../assests/service_points/hardware_1-line-46.svg";
import { ReactComponent as SupportIcon } from "../../../../../assests/service_points/e-commerce_2-line-74.svg";

function Servicespoint() {
  const pRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (pRef.current) {
      observer.observe(pRef.current);
    }

    return () => {
      if (pRef.current) {
        observer.unobserve(pRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.servicespoint_wrapper}>
      <div className={styles.servicespoint_container}>
        <section className={styles.servicespoint_left}>
          <div className={styles.servicespoint_headingleft}>
            <h2>Main Features</h2>
          </div>
          <div className={styles.servicespoint_pointleft}>
            <div className={styles.servicespoint_pointpleft1}>
              <div className={styles.servicespoint_pointcercle}>{">"}</div>
              <p className={styles.servicespoint_pointp}>
                Stability without market volatility
              </p>
            </div>
            <div className={styles.servicespoint_pointpleft2}>
              <div className={styles.servicespoint_pointcercle}>{">"}</div>

              <p className={styles.servicespoint_pointp}>
                Optimized Profitability
              </p>
            </div>
            <div className={styles.servicespoint_pointpleft3}>
              <div className={styles.servicespoint_pointcercle}>{">"}</div>
              <p className={styles.servicespoint_pointp}>
                Fast and seamless global transaction
              </p>
            </div>
            <div className={styles.servicespoint_pointpleft4}>
              <div className={styles.servicespoint_pointcercle}>{">"}</div>
              <p className={styles.servicespoint_pointp}>
                Enhanced data privacy and security
              </p>
            </div>
          </div>
        </section>
        <section className={styles.servicespoint_right}>
          <div className={styles.servicespoint_headingright}>
            <h2>Service Points</h2>
            <div className={styles.servicespoint_toprow}>
              <div className={styles.servicespoint_card1}>
                {/* <div className={styles.servicespoint_iconcard1}></div> */}
                <div className={styles.icons_set}>
                  <GlobalIcon
                    className={styles.globalIcon}
                    width={50}
                    height={50}
                  />
                  <h3 className={styles.servicespoint_headingcardright}>
                    Global Accessibility
                  </h3>
                </div>
                <p className={styles.servicespoint_containcardright}>
                  Whether on desktop, mobile, tablet, or through a browser-based
                  app, Business Corner ensures seamless access to international
                  markets.
                </p>
              </div>
              <div className={styles.servicespoint_card2}>
                {/* <div className={styles.servicespoint_iconcard2}></div> */}
                <div className={styles.icons_set}>
                  <RobustIcon
                    className={styles.robustIcon}
                    width={50}
                    height={50}
                  />
                  <h3 className={styles.servicespoint_headingcardright}>
                    Robust Security
                  </h3>
                </div>
                <p className={styles.servicespoint_containcardright}>
                  Secure your business operations with multi-factor
                  authentication, including fingerprint and Face ID, ensuring
                  only you have access to your key resources.
                </p>
              </div>
            </div>
            <div className={styles.servicespoint_bottomrow}>
              <div className={styles.servicespoint_card3}>
                {/* <div className={styles.servicespoint_iconcard3}></div> */}
                <div className={styles.icons_set}>
                  <ExpertIcon
                    className={styles.expertIcon}
                    width={50}
                    height={50}
                  />
                  <h3 className={styles.servicespoint_headingcardright}>
                    Expert Team
                  </h3>
                </div>
                <p className={styles.servicespoint_containcardright}>
                  Partner with our globally certified professionals, experts in
                  international market entry, sourcing, and distribution
                  strategies.
                </p>
              </div>
              <div className={styles.servicespoint_card4}>
                {/* <div className={styles.servicespoint_iconcard4}></div> */}
                <div className={styles.icons_set}>
                  <SupportIcon
                    className={styles.supportIcon}
                    width={50}
                    height={50}
                  />
                  <h3 className={styles.servicespoint_headingcardright}>
                    Support Network
                  </h3>
                </div>
                <p className={styles.servicespoint_containcardright}>
                  Our highly rated support team is available around the clock to
                  help you navigate and grow your international market presence.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Servicespoint;
